import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(`/api/auth/verify-email/${token}`);
        const data = await response.json();
        
        if (response.ok) {
          setSuccess(true);
          setMessage('Your email has been successfully verified. You will be redirected to login.');
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          setSuccess(false);
          setMessage(data.error || 'Invalid or expired verification link');
        }
      } catch (error) {
        setSuccess(false);
        setMessage('An error occurred while verifying your email');
      } finally {
        setVerifying(false);
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Email Verification
          </h2>
        </div>
        <div className="mt-8 bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {verifying ? (
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
              <p className="mt-4 text-sm text-gray-500">Verifying your email...</p>
            </div>
          ) : (
            <div className={`text-center ${success ? 'text-green-600' : 'text-red-600'}`}>
              <p className="text-lg">{message}</p>
              {!success && (
                <button
                  onClick={() => navigate('/login')}
                  className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Back to Login
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail; 